// extracted by mini-css-extract-plugin
module.exports = {"Tab":"StepsTab_Tab__Pm1X8"};